import { Button, Loading } from '@carbon/react';
import { useState } from 'react';

export default function TestFacebookSimple() {
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState<any>(null);

  const handleTest = async () => {
    setLoading(true);
    try {
      const response = await fetch('/api/facebook-simple-test');
      const data = await response.json();
      setResults(data);
    } catch (error) {
      setResults({ 
        success: false, 
        error: error instanceof Error ? error.message : 'Unknown error' 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-6xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Simple Facebook API Test</h1>
      
      <Button onClick={handleTest} disabled={loading} className="mb-6">
        {loading ? 'Testing...' : 'Test Facebook API'}
      </Button>

      {loading && (
        <div className="flex justify-center py-8">
          <Loading description="Testing Facebook API..." />
        </div>
      )}

      {results && (
        <div className="space-y-6">
          <div className={`border rounded p-4 ${results.success ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'}`}>
            <h3 className={`font-medium ${results.success ? 'text-green-800' : 'text-red-800'}`}>
              {results.success ? 'Test Results' : 'Test Failed'}
            </h3>
          </div>

          <details className="border rounded p-4">
            <summary className="cursor-pointer font-medium">Full Response & Server Logs</summary>
            <pre className="mt-4 text-xs bg-gray-100 p-4 rounded overflow-auto max-h-96">
              {JSON.stringify(results, null, 2)}
            </pre>
          </details>

          {results.tests && (
            <div className="grid gap-4">
              <div className="border rounded p-4">
                <h4 className="font-medium mb-2">Page Info Test</h4>
                <p>Status: {results.tests.pageInfo.status}</p>
                <pre className="text-xs bg-gray-50 p-2 rounded mt-2 overflow-auto">
                  {JSON.stringify(results.tests.pageInfo.data, null, 2)}
                </pre>
              </div>

              <div className="border rounded p-4">
                <h4 className="font-medium mb-2">Feed Endpoint Test</h4>
                <p>Status: {results.tests.feed.status}</p>
                <p>Posts Count: {results.tests.feed.count}</p>
                <pre className="text-xs bg-gray-50 p-2 rounded mt-2 overflow-auto max-h-32">
                  {JSON.stringify(results.tests.feed.data, null, 2)}
                </pre>
              </div>

              <div className="border rounded p-4">
                <h4 className="font-medium mb-2">Posts Endpoint Test</h4>
                <p>Status: {results.tests.posts.status}</p>
                <p>Posts Count: {results.tests.posts.count}</p>
                <pre className="text-xs bg-gray-50 p-2 rounded mt-2 overflow-auto max-h-32">
                  {JSON.stringify(results.tests.posts.data, null, 2)}
                </pre>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}